/*
 * Login Messages
 *
 * This contains all the text for the Login container.
 */
import { defineMessages } from "@formatjs/intl";
export default defineMessages({
  header: {
    id: "auth.Login.header",
    defaultMessage: "Sign in to Coligo-LMS"
  },
  button: {
    id: "auth.Login.button",
    defaultMessage: "Sign in"
  },
  userNameLabel: {
    id: "auth.Login.userNameLabel",
    defaultMessage: "Username"
  },
  passwordLabel: {
    id: "auth.Login.passwordLabel",
    defaultMessage: "Password"
  },
  userNamePlaceHolder: {
    id: "auth.Login.userNamePlaceHolder",
    defaultMessage: "username"
  },
  passwordPlaceHolder: {
    id: "auth.Login.passwordPlaceHolder",
    defaultMessage: "password"
  },
  expirationWarning: {
    id: "auth.Login.expirationWarning",
    defaultMessage: "YOUR SESSION HAS EXPIRED. PLEASE LOG IN AGAIN."
  },
  deactivationWarning: {
    id: "auth.Login.deactivationWarning",
    defaultMessage: "Your Account is Deactivated, please refer back to your school admin."
  }
});